module.exports = __webpack_public_path__ + "static/media/bnl-logo.eadf178d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/bnl-logo.svg
// module id = 1080
// module chunks = 0